import { useParams } from "wouter";
import ENV from "@/utils/env";
import { Card, CardBadge } from "@/components/ui/card";
import { useEditorStore } from "../stores/use-editor-store";
import { Square2StackIcon } from "@heroicons/react/20/solid";

/*
 * AssetThumbnails component
 * This component is used to render the thumbnails of the assets in the sidebar of the editor.
 */
export const AssetThumbnails = () => {
  /* Stores */
  const params = useParams();

  /* Route */
  const { projectId, studyId } = params;

  /* Action */
  const { setAssetIndex } = useEditorStore((state) => state.editorActions);

  /* Store */
  const allAssetRegionData = useEditorStore((state) => state.allAssetRegionData);
  const assetIndex = useEditorStore((state) => state.assetIndex);

  /* Render */
  return (
    <>
      {allAssetRegionData?.map((asset, index) => (
        <Card
          size="small"
          key={`sidebar-left-${index}`}
          onClick={() => setAssetIndex(index)}
          imgFit="contain"
          imageUrl={`${ENV.API_PLATFORM_URL}/pipeline/renderer/images/v1?prefix=${projectId}/${studyId}&key=${asset.key}&maxWidth=100`}
          className={`cursor-pointer hover:opacity-100 ${index === assetIndex ? "opacity-100 shadow-lg" : "opacity-60"}`}
        >
          <CardBadge>
            <Square2StackIcon className="size-3 mr-2" /> {asset.regions?.length || 0}
          </CardBadge>
          <p className="font-bold p-4 truncate">{asset.name}</p>
        </Card>
      ))}
    </>
  );
};
